export default __webpack_public_path__ + "static/media/port6.ccfe3b5b.jpg";